import styled from 'styled-components';

interface Props {
  openModal: boolean;
  width?: string;
}

export const ContainerOverlay = styled.div<Props>`
  background: rgba(0, 0, 0, 0.8);
  opacity: 1;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: ${(props) => (props.openModal ? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  z-index: 1000;
  @media (max-width: 425px) {
    height: 100vh;
    max-height: 100vh;
    margin-top: 0;
    overflow: hidden;
  }
`;

export const Container = styled.div<Props>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 0px;

  .container-modal {
    width: 550px;
    max-width: 90%;
    max-height: 80vh;
    position: relative;
    background-color: #ffffff;
    padding: 40px;
    border-radius: 10px;
    overflow: auto;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    gap: 15px;
    margin-top: 40px;
    > button {
      flex: 1;
    }
  }
  .head-modal {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    h2 {
      flex: 1;
      padding-top: 8px;
    }
    button {
      background: transparent;
      font-size: 16px;
      color: var(--texto);
      padding: 10px;
      cursorPointer;
      border: none;
      border-bottom: 1px solid var(--purple7);
      &:hover {
        color: black;
      }
    }
  }
  .content-modal {
    display: flex;
    flex-direction: column;
    font-size: 16px;
    font-weight: 400;
    padding: 0px 0px;
    > p {
      text-align: center;
      margin: 15px 0px;
    }
  }
`;
